import React, {Component} from 'react';
import isEqual from 'lodash/isEqual';

import tryMe from '../../../helpers/tryMe';
import BlueButton from '../../Shared/BlueButton';
import AvatarUploader from '../../AvatarUploader/AvatarUploader';
import FormSubmit from '../../../containers/Forms/FormSubmit';
import SlateTextInput from '../../Shared/SlateTextInput';
import { SlateDialog } from '../../Shared/SlateDialog';
import Verification from '../../../containers/Verification/Verification';
import {entityNames, avatarShapes} from '../../../config/constants';
import styles from '../styles';
import './style.css';

export const VERIFICATION_DIALOG_TYPE = {
  enable2FA: '2FA',
  disable2FA: 'disable2FA',
  email: 'email',
  phone: 'phone',
}

export default class FormUserProfileDetails extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.getUserEtag();

    const {currentUser} = this.props;
    let edit = this.props.type === 'edit';

    this.props.actions.setFormState({
      name: edit ? currentUser.name : '',
      displayName: edit ? currentUser.displayName : '',
      contactInfo: {
        phone: edit ? currentUser.contactInfo.phone : '',
        email: edit ? currentUser.contactInfo.email : '',
      },
      imageUUID: edit ? currentUser.imageUUID : '',
      attachments: [],
      dataErrors: {},
    });
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (!isEqual(props.currentUser, this.props.currentUser)) {
      this.props.actions.setFormState({
        name: props.currentUser.name,
        displayName: props.currentUser.displayName,
        contactInfo: {
          phone: props.currentUser.contactInfo.phone,
          email: props.currentUser.contactInfo.email,
        },
        imageUUID: props.currentUser.imageUUID,
        attachments: [],
        dataErrors: {},
      });
    }

    if (props.entities) {
      let verifyEntity =
        props.entities[entityNames.VERIFY_PHONE_VERIFICATION_CODE];
      if (verifyEntity && verifyEntity.isUpdated) {
        this.setState({open: false});
      }
    }
  }

  showContactInfoError = () =>
    tryMe(this.props.state.dataErrors).contactInfo &&
    !this.props.state.contactInfo.email &&
    !this.props.state.contactInfo.phone;

  handleDialogOpen = (type) =>
    this.setState({open: true, type: type}, () =>
      document.body.classList.add('dialog-open'),
    );

  handleDialogClose = () =>
    this.setState({open: false, type: null}, () =>
      document.body.classList.remove('dialog-open'),
    );

  render() {
    const {actions, state, t, currentUser, type, errorAction} = this.props;

    return (
      <form onKeyPress={actions.handleKeyPress}>
        {currentUser.error && (
          <div style={styles.formError}>{currentUser.error}</div>
        )}

        <AvatarUploader
          onAddAttachment={actions.handleAddAttachment}
          onRemoveAttachment={actions.handleRemoveProfileImage}
          onRestoreAttachment={actions.handleRestoreProfileImage}
          imageUUID={state.imageUUID}
          type={type}
          t={t}
          shape={avatarShapes.CIRCLE}
        />

        <SlateDialog
          open={this.state.open}
          onClose={this.handleDialogClose}
          title={
            this.state.type === VERIFICATION_DIALOG_TYPE.email
              ? 'Verify Email'
              : this.state.type === VERIFICATION_DIALOG_TYPE.enable2FA
              ? 'Enable Two Factor Authentication'
              : this.state.type === VERIFICATION_DIALOG_TYPE.disable2FA
                ? 'Disable Two Factor Authentication'
                : 'Verify Phone'
          }
          maxWidth="sm"
          contentPadding={false}
        >
          <Verification
            type={this.state.type}
            entities={this.props.entities}
            onRequestClose={this.handleDialogClose}
            actions={actions}
          />
        </SlateDialog>

        <div
          style={
            this.showContactInfoError()
              ? Object.assign({}, styles.multiField, styles.multiFieldError)
              : styles.multiField
          }
        >
          <div className="field-with-inline-badge">
            <SlateTextInput
              name="contactInfo.email"
              type="email"
              autoComplete="email"
              placeholder={t('userProfile:email')}
              label={t('userProfile:email')}
              fullWidth={true}
              onChange={actions.handleChange}
              onBlur={actions.handleBlur}
              error={tryMe(state.dataErrors)['contactInfo.email'] || ''}
              value={tryMe(state.contactInfo).email || ''}
            />
{currentUser.contactInfo.email && (
              <div className="inline-badge-stack">
                {currentUser.contactInfo.isEmailVerified && (
                  <span className="inline-verified-badge">Verified</span>
                )}
                {currentUser.contactInfo.email2FAEnabled && (
                  <span className="inline-verified-badge">2FA Enabled</span>
                )}
              </div>
            )}
          </div>
          {currentUser.contactInfo.email && (
            <div className="field-2fa-row">
              {!currentUser.contactInfo.isEmailVerified && (
                <BlueButton
                  label="Verify Email"
                  size="small"
                  onClick={() => this.handleDialogOpen('email')}
                />
              )}
              {currentUser.contactInfo.email2FAEnabled ? (
                <BlueButton
                  label="Disable 2FA"
                  size="small"
                  onClick={() => this.handleDialogOpen('disable2FA')}
                />
              ) : (
                <BlueButton
                  label="Enable Email 2FA"
                  size="small"
                  onClick={() => this.handleDialogOpen('2FA')}
                />
              )}
            </div>
          )}

          <div className="field-with-inline-badge">
            <SlateTextInput
              name="contactInfo.phone"
              type="tel"
              autoComplete="tel-national"
              placeholder={t('userProfile:phone')}
              label={t('userProfile:phone')}
              fullWidth={true}
              onChange={actions.handlePhoneChange}
              onBlur={actions.handleBlur}
              error={tryMe(state.dataErrors)['contactInfo.phone'] || ''}
              value={tryMe(state.contactInfo).phone || ''}
              hint="For non-US numbers, include country code"
            />
{currentUser.contactInfo.phone && currentUser.contactInfo.isPhoneVerified && (
              <div className="inline-badge-stack">
                <span className="inline-verified-badge">Verified</span>
              </div>
            )}
          </div>
          {currentUser.contactInfo.phone && !currentUser.contactInfo.isPhoneVerified && (
            <div className="field-2fa-row field-2fa-row--with-hint">
              <BlueButton
                label="Verify Phone"
                size="small"
                onClick={() => this.handleDialogOpen('phone')}
              />
            </div>
          )}

          {this.showContactInfoError() && (
            <div style={styles.multiFieldErrorText}>
              {state.dataErrors.contactInfo}
            </div>
          )}
        </div>

        <SlateTextInput
          name="name"
          type="text"
          autoComplete="name"
          placeholder={t('userProfile:name')}
          label={t('userProfile:name')}
          fullWidth={true}
          onChange={actions.handleChange}
          onBlur={actions.handleBlur}
          error={tryMe(state.dataErrors).name || ''}
          value={tryMe(state).name || ''}
        />

        <SlateTextInput
          name="displayName"
          type="text"
          placeholder={t('userProfile:displayName')}
          label={t('userProfile:displayName')}
          fullWidth={true}
          onChange={actions.handleChange}
          onBlur={actions.handleBlur}
          error={tryMe(state.dataErrors).displayName || ''}
          value={tryMe(state).displayName || ''}
          hint={t('userProfile:displayNameHint')}
        />

        {errorAction && (
          <div className="form-error form-error-action">{errorAction}</div>
        )}

        <FormSubmit
          title={t('userProfile:updateProfile')}
          handleSubmit={actions.handleSubmit}
          handleMouseDown={actions.handleMouseDown}
          entityName={state.entityName}
        />
      </form>
    );
  }
}
